import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FundTags.module.css';

export const FundTag = ({
  text,
  className = '',
  color,
  fontSize,
  fontWeight,
  padding,
  borderRadius,
  boxShadow,
  style = {},
}) => {
  const combinedStyle = {
    color,
    fontSize,
    fontWeight,
    padding,
    borderRadius,
    boxShadow,
    ...style,
  };

  return (
    <span
      className={classNames(styles.fundTag, className)}
      style={combinedStyle}
    >
      {text}
    </span>
  );
};

FundTag.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  padding: PropTypes.string,
  borderRadius: PropTypes.string,
  boxShadow: PropTypes.string,
  style: PropTypes.object,
};
